import React from 'react';
import {AccordionContentStyled} from "../../../styled/Accordion";
import {useTheme} from "../Theme/ThemeContext";
import styled from "styled-components";
import LoadingData from "../Loading/LoadingData"
import { FaGlobe, FaIndustry, FaMapMarkerAlt, FaRegNewspaper } from "react-icons/fa";
import { HiOutlineOfficeBuilding, HiOutlineUsers, HiOutlineCalendar, HiOutlineChatAlt } from 'react-icons/hi';
import { BsFillInfoCircleFill } from "react-icons/bs";
import { IoMdBusiness } from "react-icons/io";
import { BiCategory } from "react-icons/bi";
import { FiExternalLink } from "react-icons/fi";


const DataContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    background: rgba(0, 153, 144, 0.1);
    padding: 1rem;
    margin: 0.5rem 0;
    border-radius: 1.25rem;

`
const CompanyHandler = ({loading, data}) => {
    const {themeName} = useTheme();

    if (loading) {
        return (
            <AccordionContentStyled theme={themeName}>
                <p>
                    Gain better knowledge of the internal workings of your fave company. Gives you better networking opportunities and talking points.
                </p>
                <LoadingData />
            </AccordionContentStyled>
        );
    }

    if (!data || Object.keys(data).length === 0) {
        return (
            <AccordionContentStyled theme={themeName}>
                <p>No company insight data available, close and reopen to retry.</p>
            </AccordionContentStyled>
        );
    }

    // Helper to format update date
    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    };

    return (
        <AccordionContentStyled theme={themeName}>
            <p>
                Gain better knowledge of the internal workings of your fave company. Gives you better networking opportunities and talking points.
            </p>
            <DataContainer>
                {/* Website */}
                {data.website && (
                    <p>
                        <FaGlobe /> <a href={data.website} target="_blank" rel="noopener noreferrer">{data.website}</a>
                    </p>
                )}

                {data.slogan && (
                    <p>
                        <HiOutlineChatAlt /> {data.slogan}
                    </p>
                )}

                {data.company_size && (
                    <p>
                        <HiOutlineUsers /> {data.company_size}
                    </p>
                )}

                {data.founded && (
                    <p>
                        <HiOutlineCalendar /> {data.founded}
                    </p>
                )}

                {/* About */}
                {data.about && (
                    <p>
                        <BsFillInfoCircleFill /> {data.about}
                    </p>
                )}

                {/* Organization Type */}
                {data.organization_type && (
                    <p>
                        <IoMdBusiness /> {data.organization_type}
                    </p>
                )}

                {/* Industry */}
                {data.industry && (
                    <p>
                        <FaIndustry /> {data.industry}
                    </p>
                )}

                {/* Headquarters */}
                {data.headquarters && (
                    <p>
                        <HiOutlineOfficeBuilding /> {data.headquarters}
                    </p>
                )}

                {/* Other Locations */}
                {Array.isArray(data.formatted_locations) && data.formatted_locations.length > 1 && (
                    <div>
                        <FaMapMarkerAlt /> <b>Other Locations:</b>
                        <ul style={{ margin: "0.5rem 0 0 1.5rem" }}>
                            {data.formatted_locations.slice(1).map((loc, idx) => (
                                <li key={idx}>{loc}</li>
                            ))}
                        </ul>
                    </div>
                )}

                {/* Specialties */}
                {data.specialties && (
                    <p>
                        <BiCategory /> <b>Specialties:</b> {data.specialties}
                    </p>
                )}
            </DataContainer>

            {/* Last 5 Updates */}
            {Array.isArray(data.updates) && data.updates.length > 0 && (
                <div style={{ marginTop: "1.5rem" }}>
                    <h4>
                        <FaRegNewspaper style={{ marginRight: 4, marginBottom: 10 }} />
                        Recent Updates
                    </h4>
                    {data.updates.slice(0, 5).map((update, idx) => (
                        <DataContainer key={idx}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <span style={{ fontWeight: 600 }}>
                                    {update.title || "Untitled"}
                                </span>
                                {update.post_url && (
                                    <a href={update.post_url} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 8 }}>
                                        <FiExternalLink title="View Post" />
                                    </a>
                                )}
                            </div>
                            <div style={{ fontSize: "0.95em", color: "#888" }}>
                                {formatDate(update.date)}
                            </div>
                            <div style={{ margin: "0.5rem 0" }}>
                                {update.text && update.text.length > 180
                                    ? update.text.slice(0, 180) + "..."
                                    : update.text}
                            </div>
                        </DataContainer>
                    ))}
                </div>
            )}
        </AccordionContentStyled>
    );
};

export default CompanyHandler;